module.exports = __webpack_public_path__ + "img/quizz-step-4-2.01119ea3.jpg";